<template>
  <user-layout style="height:calc(100vh - 100px)">
    <p class="header">智慧景区票务系统</p>
    <p class="title">微信公众号购票端——注册</p>

    <div class="form-wrapper">
      <van-field
        required
        clickable
        class="field"
        size="large"
        type="tel"
        placeholder="请输入您的手机号码"
        :maxlength="11"
        v-model="form.tel"
      />
      <van-button
        class="submitBtn"
        block
        icon="arrow"
        type="primary"
        :loading="loading"
        :disabled="loading"
        @click="handleRegister"
        ></van-button
      >
    </div>
  </user-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { createUserDetail } from '../../api/api-user';
import UserLayout from '../../layouts/UserLayout';

export default {
  components: {
    UserLayout,
  },
  data() {
    return {
      form: {
        tel: '',
      },
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    ...mapActions(['getUser']),
    checkFields() {
      return new Promise((resolve, reject) => {
        const { tel } = this.form;
        if (!tel || tel.length !== 11 || !/^\d+$/.test(tel))
          reject(new Error('手机号格式错误'));
        resolve({
          tel,
        });
      });
    },
    async handleRegister() {
      try {
        const data = await this.checkFields();
        this.loading = true;
        const feedback = await createUserDetail(data);
        console.log(feedback);
        if (feedback) {
          await this.getUser();
          this.$router.push('/');
        }
      } catch (e) {
        this.$toast.fail(e.message);
      }
      setTimeout(() => {
        this.loading = false;
      }, 300);
    },
  },
};
</script>

<style lang="less" scoped>
.user-layout{
  width: 100%;
  height: 100%;
  position: relative;
  background-image: url('../../assets/img/register_bg.jpg');
  background-size: 100% 100%;
  z-index: 0;
}
.user-layout:after{
    content: "";
    width:100%;
    height:100%;
    position: absolute;
    left:0;
    top:0;
    background: inherit;
    filter: blur(3px);
    z-index: -1;
}
.header {
  font-size: 9vw;
  color: #fff;
  margin: 10vh auto 1vh;
}
::-webkit-input-placeholder{
  color: red;
}
.title{
  font-size: 5vw;
  color: #222;
  margin: 0 1vw 10vh;
}
.field{
  font-size: 6vw;
  background-color: transparent;
  color: #fff;
  width: 70vw;
  font-weight: lighter;
  margin-bottom: 8vh;
}
.field:after{
  border-bottom: 3px solid #eee;
  border-left: 3px solid #eee;
}
/deep/.field input::-webkit-input-placeholder{
  color: #eee;
}
.field:active{
  background-color: transparent;
}
.submitBtn{
  width: 70px;
  height: 70px;
  border-radius: 50%;
  float: right;
  background-color: #0087C9;
  border: 0;
  margin-right: 5vw;
  animation: colorswitch 15s infinite;
}

@keyframes colorswitch {
	0% {
		background: #0087C9
	}
 
	15% {
		background: #EF4A53
	}
 
	30% {
		background: #FFB463
	}
 
	45% {
		background: #33D5D4
	}
 
	60% {
		background: #254356
	}
 
	75% {
		background: #5B4097
	}
 
	90% {
    background: #ff6700;
	}
}

</style>
